/**
 * Re-exported from @hyperframes/engine.
 * @see engine/src/utils/parityContract.ts for implementation.
 */
export { quantizeTimeToFrame, MEDIA_VISUAL_STYLE_PROPERTIES } from "@hyperframes/engine";
